// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610230735/js/" + chunkId + "." + {"44":"941e1d35","225":"916b8ebe","481":"8759eacb","486":"6e9beb1f","770":"cd69414c"}[chunkId] + ".0.3853328685377163.chunk.js";
};